import SimpleCrudForm from "../../components/crud/SimpleCrudForm";

export default function FlashSaleForm() {
  return (
    <SimpleCrudForm
      title="Flash Sale"
      apiPath="/flash-sales"
      listRoute="/flash-sales"
      initialData={{ name: "", description: "", discountPercent: 10, fromDate: "", toDate: "", status: true }}
      fields={[
        { name: "name", label: "Name", required: true },
        { name: "description", label: "Description", type: "textarea" },
        { name: "discountPercent", label: "Discount %", type: "number", required: true },
        { name: "fromDate", label: "From Date", type: "date" },
        { name: "toDate", label: "To Date", type: "date" },
        { name: "status", label: "Active", type: "checkbox" },
      ]}
    />
  );
}
